<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <KhlAiOrderListContent />
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import KhlAiOrderListContent from './components/KhlAiOrderListContent.vue'

export default {
  name: 'KhlAiOrderList',
  components: {
    PageHeaderLayout,
    KhlAiOrderListContent,
  },
  data() {
    return {
      activeTab: 'aigc'
    }
  }
}
</script>

<style scoped lang="scss">
.main-page-content {
  background: #fff;
  padding: 20px;
  padding-bottom: 60px;
}
</style>
